const AssignDepartment = {

    // FIELDS
    "staff": "Staff",
    "department": "Department",
    "search": "Search",

    // PAGE HEADER
    "assign_department": "Assign Department",

    // TABLE HEADER
    "table_staff": "STAFF",
    "table_department": "DEPARTMENT",

    // ERROR
    "error_staff": "Select Staff",
    "error_department": "Select Department",

}

export default AssignDepartment;